import React from "react";
import "../../../styles/BoatList.scss";
import "./Reschedule.scss";
import { Link } from "react-router-dom";
import NavBar from "../../common/forms/NavbarCopy";
import { subDirectory } from "../../../config.json";
import { Row, Col, Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { getBookingsToShow } from "../../../services/RescheduleService";
import moment from "moment";
import { getLocalStorageValues } from "../../../services/boat";
import { SkReschedulingCard } from "../../common/skeleton/subcatCardSkeleton";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { Skeleton } from "antd";

class Reschedule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      BookingsToShow: [],
      currentdate: moment(new Date()).format("DD-MM-YYYY"),
      SendValue: [],
      isReschedulingLoading: true,
      isReschedulingAvailable: false,
    };
  }
  componentDidMount = async () => {
    await this.getBookingsToShow();
  };
  getBookingsToShow = async () => {
    let data = {
      QueryType: "PublicRescheduleHdrDetails",
      BookingId: "0",
      BoatHouseId: "0",
      FromDate: this.state.currentdate,
      ToDate: this.state.currentdate,
      UserId: getLocalStorageValues("UserId"),
      MobileNo: getLocalStorageValues("MobileNo"),
      RescheduleType: "Customer",
      stgBookingPin: "",
      RescheduleOldDate: "",
      RescheduleNewDate: "",
    };
    const res = await getBookingsToShow(data);

    if (res.data.Table?.length > 0) {
      this.setState({ BookingsToShow: res.data.Table, isReschedulingLoading: false, isReschedulingAvailable: true });
    } else {
      this.setState({ BookingsToShow: [], isReschedulingLoading: false, isReschedulingAvailable: false });
    }
    // await this.setState({ loading: false });
  };

  passingValuesthroughprops = async (rescheduleInfo) => {
    this.props.history.push({
      pathname: `${subDirectory}/Rescheduleinfo`,
      state: {
        RescheduleInfo: rescheduleInfo,
      },
    });
  };
  render() {
    const { isReschedulingLoading, isReschedulingAvailable } = this.state;
    console.log(this.state);
    return (
      <div className="boatlistmainblock">
        <NavBar {...this.props} />

        <div className="Boatrescheduleblock">
          <div className="boatschedulecardblock">
            <div className="d-flex justify-content-between flex-wrap mt-3 mx-auto" style={{ width: "90%" }}>
              {/* <div
                className="d-flex align-items-center "
                style={{ fontSize: "16px", color: "white", cursor:  "pointer" }}
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                <BsArrowLeft className="mr-2" />
                Back
              </div> */}
              <div className="">
                <Link to={`${subDirectory}/RescheduleHistory`}>
                  <div className="headofreschedulehis">
                    <BsArrowLeft className="ml-2" /> Reschedule History
                  </div>
                </Link>
              </div>
              <div className="d-flex justify-content-center" style={{ marginRight: "15%" }}>
                <div className="headofreschedule ">Boat Reschedule</div>
              </div>
              <div></div>
            </div>

            {/* <div className="mttop">
              <Link to={`${subDirectory}/RescheduleHistory`}>
                {" "}
                <div className="headofreschedulehis ">Reschedule History</div>
              </Link>
            </div> */}
            {/* <hr /> */}
            {isReschedulingLoading && (
              <Row className="rsrow1">
                <Col md={12}>
                  <div className="reschedulecard1-info container my-4 mx-auto ">
                    {/* <SkReschedulingCard /> */}
                    <Skeleton loading={isReschedulingLoading} active />
                  </div>
                </Col>
              </Row>
            )}

            <Row className="rsrow1">
              <Col md={12}>
                {this.state.BookingsToShow.length > 0 &&
                  this.state.BookingsToShow.map(
                    (i, j) =>
                      !isReschedulingLoading &&
                      isReschedulingAvailable && (
                        <div className="reschedulecard1-info  container my-4 mx-auto ">
                          <Row>
                            <Col md={8} className="">
                              <div className="boatnameres">
                                <div className="text-left">{i.BoatHouseName}</div>
                              </div>

                              <div className="">
                                <table className="reschedule-available-list-table">
                                  <tr className="">
                                    <td className="">Booking-Id </td>
                                    <td className="">:</td> <td className="">{i.BookingId}</td>
                                  </tr>
                                  <tr className="">
                                    <td className=""> Booking Date</td> <td className="">:</td>
                                    <td className="">{i?.BookingDate?.split(" ")[0]}</td>
                                  </tr>
                                  <tr className="">
                                    <td className=""> Booking PIN</td> <div className="">:</div>
                                    <td className="">{i.BookingPin}</td>
                                  </tr>
                                  <tr className=" ">
                                    <td className=""> Class </td>
                                    <td className="">:</td>
                                    <td className="">{i.PremiumStatus}</td>
                                  </tr>
                                </table>
                              </div>
                            </Col>
                            <Col md={4} className="d-flex align-items-end justify-content-end">
                              {/* <div className="resheadvalcost">₹{i.InitBillAmount}</div> */}

                              <div className=" mb-3">
                                <Button className="reschedulebtn" onClick={() => this.passingValuesthroughprops(i)}>
                                  Reschedule
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )
                  )}
                {!isReschedulingLoading && this.state.BookingsToShow.length === 0 && (
                  <div className="d-flex justify-content-center">
                    <div className="resnodata">No Data Found</div>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

export default Reschedule;
